import { RouteConfig } from 'vue-router';

import List from './views/List.vue';
import Form from './views/Form.vue';
import InvoiceContact from './views/InvoiceContact.vue';

export default [
  // list
  {
    name: 'costcenter',
    path: '',
    component: List,
  },
  // edit
  {
    path: ':id(new|\\d+)',
    component: Form,
    meta: {
      hideMenu: true,
      hideTab: true,
    },
  },
  // invoice contact
  {
    path: ':id(\\d+)/invoicecontact',
    component: InvoiceContact,
    meta: {
      hideMenu: true,
      hideTab: true,
    },
  },
] as RouteConfig[];
